import Ripple from 'vue-ripple-directive'
import { required } from '@validations'
import { mapGetters } from 'vuex'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import BCardCode from '@core/components/b-card-code'
import DatePicker from 'vue-persian-datetime-picker'
import LegalApis from '@/services/apis/documents/legal'
import ProfileApis from '@/services/apis/profile'
import { alphanumeric } from '@/mixins/alphanumeric'

const profile = new ProfileApis()
const legal = new LegalApis()

export default {
  components: {
    flatPickr,
    vSelect,
    BCardCode,
    DatePicker,
  },
  directives: {
    Ripple,
  },
  mixins: [alphanumeric],
  data() {
    return {
      maxUploadSize: '5MB',
      show: false,
      uploadSize: 0,
      currentUpload: 0,
      required,
      pending: false,
      form: {
        company_name: '',
        company_national_id: '',
        registration_city: '',
        registration_date: '',
        company_type_id: '',
        legal_representative_name: '',
        file_proof: [],

      },
      companyType: [],
      legalInfos: [],
    }
  },

  watch: {
    lang() {
      this.getCompanyType()
    },
  },
  computed: {
    ...mapGetters(['getCitizenship']),

    lang() {
      return this.$i18n.locale
    },
  },
  async created() {
    await this.getData()
    await this.getCompanyType()
    this.show = false
  },
  methods: {
    async getData() {
      this.show = true
      await legal.getDocumentLegalInfo().then(res => {
        this.legalInfos = res.data.results
      })
    },
    async getCompanyType() {
      await legal.getCompanyTypes().then(res => {
        this.companyType = res.data.results
      })
    },
    async submit() {
      const success = await this.$refs.legalCompaniesTab.validate()
      if (success) {
        const imageSize = (process.env.VUE_APP_RESIZE_IMAGE_SIZE ? process.env.VUE_APP_RESIZE_IMAGE_SIZE : 3072) * 1024
        const file_proof_f = []
        for (const item of this.form.file_proof) {
          file_proof_f.push(item.file)
        }
        const data = { ...this.form, file_proof: file_proof_f }

        delete data.file_proof_f
        this.pending = true
        await legal.saveDocumentLegal(data, e => {
          this.uploadSize = e.total
          this.currentUpload = e.loaded
        }).then(res => {
          this.$swal({
            title: res.data.message,
            icon: 'success',
            timer: 2500,
            showConfirmButton: false,
          })
          this.legalInfos = [res.data.results.legalCompanies[0]]
          this.pending = false
          profile.get()
        })
          .finally(() => {
            this.pending = false
            this.uploadSize = 0
            this.currentUpload = 0
          })
      }
    },
    baseUrl() {
      return process.env.VUE_APP_BASE_IMAGE_URL
    },
    onBeforeDelete(fileRecord) {
      const i = this.form.file_proof.indexOf(fileRecord)
      if (i !== -1) {
        // queued file, not yet uploaded. Just remove from the arrays
        this.form.file_proof.splice(i, 1)
      }
    },

  },

}
